module.exports = __webpack_public_path__ + "img/gry_9.8485ba3f.png";